import { SET_MAIN_CARD } from '@/store/mutation-types'
const dadosEstado = require('@/constants/' + process.env.ESTADO + '/dadosEstado')
const state = {
  showMainCard: true,
  dadosEstado: dadosEstado.default
}

const mutations = {
  [SET_MAIN_CARD] (state, payload) {
    state.showMainCard = payload
  }
}

const actions = {
  async setMainCardVisibility ({ commit }, isVisible) {
    commit(SET_MAIN_CARD, isVisible)
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/userInterface.js